<!-- ============================================================= -->
<!-- VISTA PÚBLICA DEL PERFIL ACADÉMICO                            -->
<!-- Sobre mí / Habilidades / Certificados obtenidos /             -->
<!-- Experiencia laboral / Educación: datos reales.                -->
<!-- ============================================================= -->

<!-- ============================= MODAL COMPARTIR ============================= -->
<div *ngIf="showShareMenu" class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[1000000] p-4"
    (click)="closeShare()">
    <div class="w-full max-w-xs rounded-xl border border-gray-200 bg-white shadow-xl p-4"
        (click)="$event.stopPropagation()">
        <div class="flex items-center justify-between mb-3">
            <p class="text-sm font-bold text-gray-700">{{ "words.share-profile" | translate }}</p>
            <button type="button" (click)="closeShare()" [attr.aria-label]="'words.close' | translate"
                class="text-gray-400 hover:text-gray-700 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-x w-4 h-4">
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                </svg>
            </button>
        </div>
        <div class="grid grid-cols-4 gap-1.5">
            <a [href]="shareFacebook" target="_blank" rel="noopener noreferrer" title="Facebook"
                class="flex flex-col items-center gap-1 rounded-lg py-2 hover:bg-gray-50 transition">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-facebook w-5 h-5 text-[#1877F2]">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
                <span class="text-[11px] text-gray-600">Facebook</span>
            </a>
            <a [href]="shareTwitter" target="_blank" rel="noopener noreferrer" title="Twitter"
                class="flex flex-col items-center gap-1 rounded-lg py-2 hover:bg-gray-50 transition">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-twitter w-5 h-5 text-[#1DA1F2]">
                    <path
                        d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z">
                    </path>
                </svg>
                <span class="text-[11px] text-gray-600">Twitter</span>
            </a>
            <a [href]="shareLinkedIn" target="_blank" rel="noopener noreferrer" title="LinkedIn"
                class="flex flex-col items-center gap-1 rounded-lg py-2 hover:bg-gray-50 transition">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-linkedin w-5 h-5 text-[#0A66C2]">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z">
                    </path>
                    <rect width="4" height="12" x="2" y="9"></rect>
                    <circle cx="4" cy="4" r="2"></circle>
                </svg>
                <span class="text-[11px] text-gray-600">LinkedIn</span>
            </a>
            <a [href]="shareEmail" target="_blank" rel="noopener noreferrer" title="Email"
                class="flex flex-col items-center gap-1 rounded-lg py-2 hover:bg-gray-50 transition">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-mail w-5 h-5 text-gray-600">
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                </svg>
                <span class="text-[11px] text-gray-600">Email</span>
            </a>
        </div>
        <button type="button" (click)="copyLink()"
            class="mt-2 w-full inline-flex items-center justify-center gap-2 text-xs font-medium rounded-lg py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 transition">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-link w-3.5 h-3.5">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
            </svg>
            {{ (linkCopied ? 'words.link-copied' : 'words.copy-link') | translate }}
        </button>
    </div>
</div>

<div class="min-h-screen bg-[#EFF1F5] flex flex-col">

    <!-- ===================== BLOQUE STICKY: navbar + franja de nombre juntos ===================== -->
    <div class="sticky top-0 z-50">
        <!-- Navbar de PLATAFORMA: solo si el DUEÑO del perfil está logueado -->
        <msc-header *ngIf="showAuthenticatedNavbar" [company]="sessionCompany" [access]="sessionAccess"
            [forcePublicProfileNav]="true"></msc-header>

        <!-- Navbar PÚBLICO -->
        <nav *ngIf="!showAuthenticatedNavbar" class="py-2 bg-white">
            <div class="mx-auto max-w-5xl px-4">
                <div class="flex items-center justify-between w-full h-14 pl-5 pr-3 rounded-full"
                    style="background: #ffffff;"
                    [style.box-shadow]="showStickyNameBar ? 'rgba(0, 0, 0, 0.1) 0px 2px 24px' : 'none'"
                    [style.backdrop-filter]="showStickyNameBar ? 'blur(16px)' : 'none'">
                    <a href="/" class="flex items-center">
                        <img src="https://webservices.griky.co/cdn/img/Griky-Logotipo.webp" alt="Griky"
                            class="h-6 object-contain">
                    </a>
                    <div class="flex items-center gap-2">
                        <a [routerLink]="['/login']"
                            class="inline-flex items-center text-sm font-semibold text-gray-600 rounded-full px-4 py-1.5 hover:text-secondary transition-colors">{{
                            "auth.login" | translate }}</a>
                        <a href="https://webcampus.griky.co"
                            class="inline-flex items-center text-sm font-semibold text-primary border border-primary rounded-full px-4 py-1.5 hover:bg-primary-500 hover:text-white transition-colors">{{
                            "words.join-now" | translate }}</a>
                    </div>
                </div>
            </div>
        </nav>

        <!-- Franja: nombre + Compartir, solo visible al hacer scroll hacia abajo -->
        <div *ngIf="showStickyNameBar" class="bg-white border-b border-gray-100">
            <div class="max-w-5xl mx-auto px-6 md:px-12 py-3 flex items-center justify-between gap-3">
                <div class="min-w-0">
                    <p class="text-base font-semibold text-gray-700 truncate">{{ shortName }}</p>
                    <p *ngIf="subtitle" class="text-xs text-gray-500 truncate">{{ subtitle }}</p>
                </div>
                <button type="button" (click)="toggleShare()"
                    class="inline-flex items-center gap-2 rounded-full bg-primary text-white text-xs font-semibold px-4 py-2 hover:opacity-90 transition-colors shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-share2 w-4 h-4">
                        <circle cx="18" cy="5" r="3"></circle>
                        <circle cx="6" cy="12" r="3"></circle>
                        <circle cx="18" cy="19" r="3"></circle>
                        <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line>
                        <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line>
                    </svg>
                    {{ "words.share" | translate }}
                </button>
            </div>
        </div>
    </div>

    <!-- ===================== HEADER: banner + avatar + datos ===================== -->
    <!-- ===================== HEADER: banner + avatar + datos ===================== -->

    <header class="relative">

        <!--

            Banner 100% CSS: fondo plano y facetas diagonales recortadas con clip-path —

            una cuña chica en la esquina superior izquierda y una faceta en el lado derecho.

            Sin imágenes ni SVG. Los colores salen de los tokens de marca

            (--v2-color-primary-*), así que el banner se adapta a cada company.

        -->

        <div class="mt-12 md:mt-0 relative h-[150px] overflow-hidden" style="background-color: var(--v2-color-primary-500);">

            <!-- Móvil: menú de tres puntos (con "Compartir") sobre el banner, a la derecha -->
            <div class="pp-mobile-only absolute inset-x-0 top-0 z-20 flex items-center justify-end px-4 py-3">
                <div class="relative">
                    <button type="button" (click)="toggleMobileHeaderMenu($event)" [attr.aria-label]="'words.more-options' | translate"
                        class="w-9 h-9 rounded-full bg-black/35 backdrop-blur-sm flex items-center justify-center text-white hover:bg-black/50 transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-ellipsis-vertical w-5 h-5">
                            <circle cx="12" cy="12" r="1"></circle>
                            <circle cx="12" cy="5" r="1"></circle>
                            <circle cx="12" cy="19" r="1"></circle>
                        </svg>
                    </button>
                    <div *ngIf="showMobileHeaderMenu" (click)="$event.stopPropagation()"
                        class="absolute right-0 top-11 w-44 rounded-xl bg-white shadow-xl border border-gray-100 py-1.5 z-30">
                        <button type="button" (click)="showMobileHeaderMenu = false; toggleShare()"
                            class="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-share2 w-4 h-4 text-gray-500 shrink-0">
                                <circle cx="18" cy="5" r="3"></circle>
                                <circle cx="6" cy="12" r="3"></circle>
                                <circle cx="18" cy="19" r="3"></circle>
                                <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line>
                                <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line>
                            </svg>
                            {{ "words.share" | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- Cuña de la esquina superior izquierda -->

            <div class="absolute inset-0 pointer-events-none"
                style="background-color: var(--v2-color-primary-500); opacity: 0.09; clip-path: polygon(0 0, 9% 0, 0 30%);">

            </div>



            <!-- Faceta derecha: diagonal desde arriba hacia el borde inferior derecho -->

            <div class="absolute inset-0 pointer-events-none"
                style="background-color: var(--v2-color-primary-400); opacity: 0.07; clip-path: polygon(88% 0, 100% 0, 100% 100%);">

            </div>

        </div>

        <div class="bg-white">

            <div class="max-w-5xl mx-auto px-6 md:px-12 pb-8">

                <div class="relative z-10 -mt-[68px] w-[122px] h-[122px] rounded-full p-1 bg-primary">

                    <img *ngIf="hasUploadedPicture" [src]="me.picture + '?size=256'" [alt]="shortName"
                        class="w-full h-full rounded-full object-cover ring-4 ring-white">

                    <div *ngIf="!hasUploadedPicture"
                        class="w-full h-full rounded-full ring-4 ring-white bg-gray-100 flex items-center justify-center">

                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-10 h-10 text-gray-400">

                            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>

                            <circle cx="12" cy="7" r="4"></circle>

                        </svg>

                    </div>

                </div>

                <div class="mt-5 flex flex-wrap items-center justify-between gap-x-3 gap-y-1">

                    <div class="flex flex-wrap items-center gap-x-3 gap-y-1">

                        <h1 class="text-2xl font-semibold tracking-tight text-gray-700">{{ shortName }}</h1>

                        <span *ngIf="hasVerifiedBadge"
                            class="inline-flex rounded-full bg-[#EAF7EF] px-3 py-1 text-xs font-semibold text-[#1B7A4B]">

                            {{ "words.verified-by" | translate }} {{ company?.name }}

                        </span>

                    </div>

                    <div class="pp-desktop-only">
                    <div class="flex items-center gap-3">

                        <button type="button" (click)="toggleShare()"
                            class="inline-flex items-center gap-2 rounded-full bg-primary text-white text-sm font-semibold px-5 py-2.5 hover:opacity-90 transition-colors">

                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-share2 w-4 h-4">

                                <circle cx="18" cy="5" r="3"></circle>

                                <circle cx="6" cy="12" r="3"></circle>

                                <circle cx="18" cy="19" r="3"></circle>

                                <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line>

                                <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line>

                            </svg>

                            {{ "words.share" | translate }}

                        </button>

                    </div>
                    </div>

                </div>

                <div *ngIf="role || me?.city" class="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-base text-gray-500">

                    <span *ngIf="role">{{ role }}</span>

                    <span *ngIf="role && me?.city" class="text-gray-300">&bull;</span>

                    <span *ngIf="me?.city">{{ me.city }}</span>

                </div>



                <!-- Métricas pequeñas debajo del rol/ciudad: solo si hay algo que mostrar -->

                <div *ngIf="(grikySkillsEnabled && unlockedAchievements.length > 0) || certificates.length > 0"
                    class="flex flex-wrap items-center gap-x-6 gap-y-1 text-sm text-gray-600"
                    [ngClass]="(role || me?.city) ? 'mt-4' : 'mt-1.5'">
                    <!-- contenido completado
                    <span *ngIf="isOwnerViewing">
                        <span class="font-semibold" [style.color]="isZeroMetric(statusCounts.completed) ? '#B4B2A9' : ''">{{ metricText(statusCounts.completed) }}</span>
                        <span [style.color]="isZeroMetric(statusCounts.completed) ? '#888780' : ''"> {{ "words.completed-contents-label" | translate }}</span>
                    </span>-->

                    <span *ngIf="grikySkillsEnabled && unlockedAchievements.length > 0">

                        <span class="font-semibold">{{ metricText(unlockedAchievements.length) }}</span>

                        <span> {{ (unlockedAchievements.length === 1 ? 'words.achievement-earned-singular' :
                            'words.achievements-earned-plural') | translate }}</span>

                    </span>

                    <span *ngIf="certificates.length > 0">

                        <span class="font-semibold">{{ metricText(certificates.length) }}</span>

                        <span> {{ (certificates.length === 1 ? 'words.certificate-earned-singular' :
                            'words.certificates-earned-plural') | translate }}</span>

                    </span>

                </div>

            </div>

        </div>

    </header>

    <!-- ===================== NAV DE SECCIONES ===================== -->
    <div *ngIf="availableProfileSectionsCount > 0" class="bg-white border-t border-gray-100">
        <div class="max-w-5xl mx-auto px-6 md:px-12 flex items-center gap-8 overflow-x-auto">
            <button *ngIf="availableProfileSectionsCount >= 3" type="button" (click)="setActiveSection('resumen')"
                class="relative pt-3 pb-3 text-[15px] whitespace-nowrap transition-colors hover:text-[#22304C]"
                [style.color]="effectiveActiveSection === 'resumen' ? activeTabColor : 'rgb(95, 104, 119)'"
                [style.font-weight]="effectiveActiveSection === 'resumen' ? 700 : 400">
                {{ "words.summary" | translate }}
                <span class="absolute left-0 right-0 bottom-0 h-[3px] rounded-full transition-opacity"
                    [style.background-color]="effectiveActiveSection === 'resumen' ? activeTabColor : 'transparent'"
                    [style.opacity]="effectiveActiveSection === 'resumen' ? 1 : 0"></span>
            </button>
            <button *ngIf="me?.biography" type="button" (click)="setActiveSection('about')"
                class="relative pt-3 pb-3 text-[15px] whitespace-nowrap transition-colors hover:text-[#22304C]"
                [style.color]="effectiveActiveSection === 'about' ? activeTabColor : 'rgb(95, 104, 119)'"
                [style.font-weight]="effectiveActiveSection === 'about' ? 700 : 400">
                {{ "words.presentation" | translate }}
                <span class="absolute left-0 right-0 bottom-0 h-[3px] rounded-full transition-opacity"
                    [style.background-color]="effectiveActiveSection === 'about' ? activeTabColor : 'transparent'"
                    [style.opacity]="effectiveActiveSection === 'about' ? 1 : 0"></span>
            </button>
            <button *ngIf="experiences.length || education.length || (grikySkillsEnabled && acquiredSkills.length)" type="button"
                (click)="setActiveSection('trajectory')"
                class="relative pt-3 pb-3 text-[15px] whitespace-nowrap transition-colors hover:text-[#22304C]"
                [style.color]="effectiveActiveSection === 'trajectory' ? activeTabColor : 'rgb(95, 104, 119)'"
                [style.font-weight]="effectiveActiveSection === 'trajectory' ? 700 : 400">
                {{ "words.trajectory" | translate }}
                <span class="absolute left-0 right-0 bottom-0 h-[3px] rounded-full transition-opacity"
                    [style.background-color]="effectiveActiveSection === 'trajectory' ? activeTabColor : 'transparent'"
                    [style.opacity]="effectiveActiveSection === 'trajectory' ? 1 : 0"></span>
            </button>
            <button *ngIf="certificates.length > 0 || externalCerts.length > 0" type="button"
                (click)="setActiveSection('credentials')"
                class="relative pt-3 pb-3 text-[15px] whitespace-nowrap transition-colors hover:text-[#22304C]"
                [style.color]="effectiveActiveSection === 'credentials' ? activeTabColor : 'rgb(95, 104, 119)'"
                [style.font-weight]="effectiveActiveSection === 'credentials' ? 700 : 400">
                {{ "words.credentials-title" | translate }}
                <span class="absolute left-0 right-0 bottom-0 h-[3px] rounded-full transition-opacity"
                    [style.background-color]="effectiveActiveSection === 'credentials' ? activeTabColor : 'transparent'"
                    [style.opacity]="effectiveActiveSection === 'credentials' ? 1 : 0"></span>
            </button>
            <button *ngIf="grikySkillsEnabled && unlockedAchievements.length > 0" type="button"
                (click)="setActiveSection('recognitions')"
                class="relative pt-3 pb-3 text-[15px] whitespace-nowrap transition-colors hover:text-[#22304C]"
                [style.color]="effectiveActiveSection === 'recognitions' ? activeTabColor : 'rgb(95, 104, 119)'"
                [style.font-weight]="effectiveActiveSection === 'recognitions' ? 700 : 400">
                {{ "words.stats-recognitions-title" | translate }}
                <span class="absolute left-0 right-0 bottom-0 h-[3px] rounded-full transition-opacity"
                    [style.background-color]="effectiveActiveSection === 'recognitions' ? activeTabColor : 'transparent'"
                    [style.opacity]="effectiveActiveSection === 'recognitions' ? 1 : 0"></span>
            </button>
        </div>
    </div>

    <!-- ===================== CONTENIDO PRINCIPAL ===================== -->
    <main *ngIf="availableProfileSectionsCount > 0"
        class="flex-1 max-w-5xl w-full mx-auto px-6 md:px-12 py-8 space-y-5">

        <!-- ===== Presentación ===== -->
        <ng-container
            *ngIf="(effectiveActiveSection === 'resumen' || effectiveActiveSection === 'about') && me?.biography">
            <div *ngIf="!isSingleSectionMode" class="flex items-center gap-3 pt-3">
                <span class="text-[11px] font-bold uppercase tracking-[0.18em] text-gray-400 whitespace-nowrap">{{
                    "words.presentation" | translate }}</span>
                <span class="h-px flex-1 bg-gray-200"></span>
            </div>
            <section class="bg-white  md:rounded-lg box-cards  p-6">
                <h2 class="text-base font-semibold text-gray-700">{{ "words.about-user-title" | translate }}</h2>
                <div class="mt-4">
                    <p #bioText class="text-sm text-gray-500 leading-relaxed"
                        [ngClass]="{ 'line-clamp-4': !bioExpanded }">{{ me.biography }}</p>
                    <button *ngIf="bioOverflowing" type="button" (click)="bioExpanded = !bioExpanded"
                        class="mt-1.5 text-xs font-semibold text-primary hover:opacity-80 transition">
                        {{ (bioExpanded ? 'words.see-less' : 'words.see-more') | translate }}
                    </button>
                </div>
            </section>
        </ng-container>

        <!-- ===== Sin información: presentación y trayectoria vacías ===== -->
        <ng-container
            *ngIf="(activeSection === 'resumen') && !me?.biography && !experiences.length && !education.length">
            <section
                class="bg-white  md:rounded-lg box-cards  p-6 flex flex-col items-center text-center gap-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-file-text text-gray-400">
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                    <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                    <path d="M10 9H8"></path>
                    <path d="M16 13H8"></path>
                    <path d="M16 17H8"></path>
                </svg>
                <p class="text-sm text-gray-500">{{ "words.profile-no-info" | translate }}</p>
            </section>
        </ng-container>


        <!-- ===== Trayectoria: Experiencia laboral + Educación + Certificaciones externas ===== -->
        <ng-container
            *ngIf="(effectiveActiveSection === 'resumen' || effectiveActiveSection === 'trajectory') && (experiences.length || education.length || (grikySkillsEnabled && acquiredSkills.length))">
            <div *ngIf="!isSingleSectionMode" class="flex items-center gap-3 pt-3">
                <span class="text-[11px] font-bold uppercase tracking-[0.18em] text-gray-400 whitespace-nowrap">{{
                    "words.trajectory" | translate }}</span>
                <span class="h-px flex-1 bg-gray-200"></span>
            </div>
            <section class="bg-white  md:rounded-lg box-cards  p-6">
                <h2 style="display:none" class="text-lg font-bold text-gray-800">
                    {{ (isSingleProfessionalSubTab ? singleProfessionalSubTabTitleKey : "words.professional-profile") | translate }}
                </h2>

                <!-- Con 2 secciones: ambas se muestran apiladas por completo, sin pestañas (ver bloque isStackedProfessionalMode más abajo) -->
                <ng-container *ngIf="!isStackedProfessionalMode">

                <!-- Pestañas internas: Resumen / Experiencia Laboral / Educación / Certificaciones (solo con 3+ secciones con contenido) -->
                <div *ngIf="professionalSubTabsCount >= 3" class="mb-4 flex items-center gap-6 overflow-x-auto border-b border-gray-100">
                    <button *ngIf="professionalSubTabsCount >= 3" type="button" (click)="setProfileSubTab('resumen')"
                        class="shrink-0 pb-2 text-sm font-medium transition-colors border-b-2"
                        [ngClass]="effectiveProfileSubTab === 'resumen' ? 'text-gray-700 border-primary' : 'text-gray-500 border-transparent hover:text-gray-700'">
                        Resumen
                    </button>
                    <button *ngIf="experiences.length" type="button" (click)="setProfileSubTab('experience')"
                        class="shrink-0 pb-2 text-sm font-medium transition-colors border-b-2 gap-1.5"
                        [ngClass]="effectiveProfileSubTab === 'experience' ? 'text-gray-700 border-primary' : 'text-gray-500 border-transparent hover:text-gray-700'">
                        Experiencia Laboral <span class="rounded-full text-gray-500 text-[12px] font-semibold"> ({{
                            experiences.length }})</span>
                    </button>
                    <button *ngIf="education.length" type="button" (click)="setProfileSubTab('education')"
                        class="shrink-0 pb-2 text-sm font-medium transition-colors border-b-2 gap-1.5"
                        [ngClass]="effectiveProfileSubTab === 'education' ? 'text-gray-700 border-primary' : 'text-gray-500 border-transparent hover:text-gray-700'">
                        Educación <span class="rounded-full text-gray-500 text-[12px] font-semibold"> ({{
                            education.length }})</span>
                    </button>
                    <button *ngIf="grikySkillsEnabled && acquiredSkills.length" type="button"
                        (click)="setProfileSubTab('skills')"
                        class="shrink-0 pb-2 text-sm font-medium transition-colors border-b-2 gap-1.5"
                        [ngClass]="effectiveProfileSubTab === 'skills' ? 'text-gray-700 border-primary' : 'text-gray-500 border-transparent hover:text-gray-700'">
                        {{ "words.skills" | translate }} <span
                            class="rounded-full text-gray-500 text-[12px] font-semibold"> ({{ acquiredSkills.length
                            }})</span>
                    </button>
                </div>

                <!-- ===== Resumen: 2 columnas con los primeros 3 items de cada sección ===== -->
                <div *ngIf="effectiveProfileSubTab === 'resumen'" class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <!-- Experiencia laboral (resumen: 3 items) -->
                    <div *ngIf="experiences.length" class="rounded-xl border border-gray-200 p-4">
                        <div class="flex items-center justify-between">
                            <p class="text-sm font-semibold text-gray-700">{{ "words.work-experience" | translate }}</p>
                            <button type="button" (click)="setProfileSubTab('experience')"
                                class="inline-flex items-center gap-1 text-[11px] font-semibold text-gray-500">
                                {{ "words.see-all" | translate }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-chevron-right w-3 h-3">
                                    <path d="m9 18 6-6-6-6"></path>
                                </svg>
                            </button>
                        </div>
                        <div class="mt-4 relative">
                            <div *ngFor="let exp of sortedExperiences | slice:0:3; let last = last"
                                class="relative flex items-start gap-3" [class.pb-4]="!last">
                                <span *ngIf="!last" class="absolute left-[13px] top-7 bottom-0 w-px bg-gray-200"
                                    aria-hidden="true"></span>
                                <span
                                    class="relative z-10 w-7 h-7 rounded-lg bg-gray-100 flex items-center justify-center shrink-0">
                                    <img *ngIf="exp.logo" [src]="exp.logo" [alt]="exp.title" loading="lazy"
                                        class="w-4 h-4 object-contain">
                                    <svg *ngIf="!exp.logo" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="lucide lucide-briefcase w-3.5 h-3.5 text-gray-700">
                                        <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                        <rect width="20" height="14" x="2" y="6" rx="2"></rect>
                                    </svg>
                                </span>
                                <div class="min-w-0 flex-1">
                                    <div class="flex items-start justify-between gap-2">
                                        <p class="text-sm font-semibold leading-snug text-gray-700">{{ exp.title }}</p>
                                        <span *ngIf="exp.current"
                                            class="rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-600 shrink-0">{{
                                            "words.current" | translate }}</span>
                                    </div>
                                    <p class="mt-0.5 text-xs text-gray-500">{{ exp.period }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Educación (resumen: 3 items) -->
                    <div *ngIf="education.length" class="rounded-xl border border-gray-200 p-4">
                        <div class="flex items-center justify-between">
                            <p class="text-sm font-semibold text-gray-700">{{ "words.education" | translate }}</p>
                            <button type="button" (click)="setProfileSubTab('education')"
                                class="inline-flex items-center gap-1 text-[11px] font-semibold text-gray-500">
                                {{ "words.see-all" | translate }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-chevron-right w-3 h-3">
                                    <path d="m9 18 6-6-6-6"></path>
                                </svg>
                            </button>
                        </div>
                        <div class="mt-4 relative">
                            <div *ngFor="let edu of sortedEducation | slice:0:3; let last = last"
                                class="relative flex items-start gap-3" [class.pb-4]="!last">
                                <span *ngIf="!last" class="absolute left-[13px] top-7 bottom-0 w-px bg-gray-200"
                                    aria-hidden="true"></span>
                                <span
                                    class="relative z-10 w-7 h-7 rounded-lg bg-gray-100 flex items-center justify-center shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-graduation-cap w-3.5 h-3.5 text-gray-700">
                                        <path
                                            d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z">
                                        </path>
                                        <path d="M22 10v6"></path>
                                        <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                                    </svg>
                                </span>
                                <div class="min-w-0">
                                    <p class="text-sm font-semibold text-gray-700">{{ edu.university }}</p>
                                    <p class="mt-0.5 text-xs text-gray-500">{{ edu.career }}</p>
                                    <p class="text-xs text-gray-500">{{ edu.period }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- ===== Experiencia laboral (vista completa, 5 en 5) ===== -->
                <div *ngIf="effectiveProfileSubTab === 'experience'" class="space-y-2"
                    [class.mt-4]="isSingleProfessionalSubTab">
                    <div *ngFor="let exp of sortedExperiences | slice:0:experienceVisibleCount"
                        class="flex items-start gap-3 rounded-xl border border-gray-200 p-3">
                        <span
                            class="w-10 h-10 shrink-0 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center overflow-hidden">
                            <img *ngIf="exp.logo" [src]="exp.logo" [alt]="exp.title" loading="lazy"
                                class="w-5 h-5 object-contain">
                            <svg *ngIf="!exp.logo" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-briefcase w-5 h-5 text-gray-500">
                                <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                <rect width="20" height="14" x="2" y="6" rx="2"></rect>
                            </svg>
                        </span>
                        <div class="min-w-0 flex-1">
                            <div class="flex items-start justify-between gap-2">
                                <p class="text-sm font-semibold leading-tight text-gray-700">{{ exp.title }}</p>
                                <span *ngIf="exp.current"
                                    class="rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-600 shrink-0">{{
                                    "words.current" | translate }}</span>
                            </div>
                            <p class="text-xs text-gray-500 mt-0.5">{{ exp.period }}</p>
                        </div>
                    </div>
                    <div *ngIf="sortedExperiences.length > experienceVisibleCount" class="flex justify-center">
                        <button type="button" (click)="showMoreExperience()"
                            class="inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 transition">
                            {{ "words.see-more" | translate }} {{ sortedExperiences.length - experienceVisibleCount }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-down w-3.5 h-3.5">
                                <path d="m6 9 6 6 6-6"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- ===== Educación (vista completa, 5 en 5) ===== -->
                <div *ngIf="effectiveProfileSubTab === 'education'" class="space-y-2"
                    [class.mt-4]="isSingleProfessionalSubTab">
                    <div *ngFor="let edu of sortedEducation | slice:0:educationVisibleCount"
                        class="flex items-start gap-3 rounded-xl border border-gray-100 p-3">
                        <span
                            class="w-10 h-10 shrink-0 rounded-full bg-gray-100 border border-gray-100 flex items-center justify-center overflow-hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-graduation-cap w-5 h-5 text-gray-500">
                                <path
                                    d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z">
                                </path>
                                <path d="M22 10v6"></path>
                                <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                            </svg>
                        </span>
                        <div class="min-w-0 flex-1">
                            <p class="text-sm font-semibold leading-tight text-gray-700">{{ edu.university }}</p>
                            <p class="text-xs font-medium mt-0.5 text-gray-700">{{ edu.career }}</p>
                            <p class="text-xs text-gray-500 mt-0.5">{{ edu.period }}</p>
                        </div>
                    </div>
                    <div *ngIf="sortedEducation.length > educationVisibleCount" class="flex justify-center">
                        <button type="button" (click)="showMoreEducation()"
                            class="inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 transition">
                            {{ "words.see-more" | translate }} {{ sortedEducation.length - educationVisibleCount }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-down w-3.5 h-3.5">
                                <path d="m6 9 6 6 6-6"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- ===== Habilidades ===== -->
                <div *ngIf="effectiveProfileSubTab === 'skills'" class="flex flex-wrap gap-2"
                    [class.mt-4]="isSingleProfessionalSubTab">
                    <span *ngFor="let skill of acquiredSkills"
                        class="rounded-full bg-gray-100 border border-gray-100 px-4 py-2 text-xs font-medium text-gray-700">{{
                        skill.skillName }}</span>
                </div>

                </ng-container>

                <!-- ===== Exactamente 2 secciones: se apilan completas, sin pestañas ===== -->
                <div *ngIf="isStackedProfessionalMode" class="mt-3 space-y-6">

                    <!-- Experiencia laboral -->
                    <div *ngIf="experiences.length">
                        <p class="text-base font-semibold text-gray-700 pb-2 border-b border-gray-100">{{ "words.work-experience" | translate }}</p>
                        <div class="space-y-2 mt-3">
                            <div *ngFor="let exp of sortedExperiences | slice:0:experienceVisibleCount"
                                class="flex items-start gap-3 rounded-xl border border-gray-200 p-3">
                                <span class="w-10 h-10 shrink-0 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center overflow-hidden">
                                    <img *ngIf="exp.logo" [src]="exp.logo" [alt]="exp.title" loading="lazy"
                                        class="w-5 h-5 object-contain">
                                    <svg *ngIf="!exp.logo" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="lucide lucide-briefcase w-5 h-5 text-gray-500">
                                        <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                        <rect width="20" height="14" x="2" y="6" rx="2"></rect>
                                    </svg>
                                </span>
                                <div class="min-w-0 flex-1">
                                    <div class="flex items-start justify-between gap-2">
                                        <p class="text-sm font-semibold leading-tight text-gray-700">{{ exp.title }}</p>
                                        <span *ngIf="exp.current"
                                            class="rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-600 shrink-0">{{
                                            "words.current" | translate }}</span>
                                    </div>
                                    <p class="text-xs text-gray-500 mt-0.5">{{ exp.period }}</p>
                                </div>
                            </div>
                            <div *ngIf="sortedExperiences.length > experienceVisibleCount" class="flex justify-center">
                                <button type="button" (click)="showMoreExperience()"
                                    class="inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 transition">
                                    {{ "words.see-more" | translate }} {{ sortedExperiences.length - experienceVisibleCount }}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-chevron-down w-3.5 h-3.5">
                                        <path d="m6 9 6 6 6-6"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Educación -->
                    <div *ngIf="education.length">
                        <p class="text-base font-semibold text-gray-700 pb-2 border-b border-gray-100">{{ "words.education" | translate }}</p>
                        <div class="space-y-2 mt-3">
                            <div *ngFor="let edu of sortedEducation | slice:0:educationVisibleCount"
                                class="flex items-start gap-3 rounded-xl border border-gray-100 p-3">
                                <span class="w-10 h-10 shrink-0 rounded-full bg-gray-100 border border-gray-100 flex items-center justify-center overflow-hidden">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-graduation-cap w-5 h-5 text-gray-500">
                                        <path
                                            d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z">
                                        </path>
                                        <path d="M22 10v6"></path>
                                        <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                                    </svg>
                                </span>
                                <div class="min-w-0 flex-1">
                                    <p class="text-sm font-semibold leading-tight text-gray-700">{{ edu.university }}</p>
                                    <p class="text-xs font-medium mt-0.5 text-gray-700">{{ edu.career }}</p>
                                    <p class="text-xs text-gray-500 mt-0.5">{{ edu.period }}</p>
                                </div>
                            </div>
                            <div *ngIf="sortedEducation.length > educationVisibleCount" class="flex justify-center">
                                <button type="button" (click)="showMoreEducation()"
                                    class="inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 transition">
                                    {{ "words.see-more" | translate }} {{ sortedEducation.length - educationVisibleCount }}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-chevron-down w-3.5 h-3.5">
                                        <path d="m6 9 6 6 6-6"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Habilidades -->
                    <div *ngIf="grikySkillsEnabled && acquiredSkills.length">
                        <p class="text-base font-semibold text-gray-700 pb-2 border-b border-gray-100">{{ "words.skills" | translate }}</p>
                        <div class="flex flex-wrap gap-2 mt-3">
                            <span *ngFor="let skill of acquiredSkills"
                                class="rounded-full bg-gray-100 border border-gray-100 px-4 py-2 text-xs font-medium text-gray-700">{{
                                skill.skillName }}</span>
                        </div>
                    </div>

                </div>

            </section>
        </ng-container>

        <!-- ===== Credenciales: Certificados de Griky + Certificaciones externas ===== -->
        <ng-container
            *ngIf="(effectiveActiveSection === 'resumen' || effectiveActiveSection === 'credentials') && (certificates.length > 0 || externalCerts.length > 0)">
            <div *ngIf="!isSingleSectionMode" class="flex items-center gap-3 pt-3">
                <span class="text-[11px] font-bold uppercase tracking-[0.18em] text-gray-400 whitespace-nowrap">{{
                    "words.credentials-title" | translate }}</span>
                <span class="h-px flex-1 bg-gray-200"></span>
            </div>

            <section *ngIf="certificates.length > 0" class="bg-white  md:rounded-lg box-cards  p-6">
                <div class="flex items-baseline justify-between gap-4">
                    <div>
                        <h2 class="text-base font-semibold text-gray-700">{{ "words.certificates" | translate }} <span
                                class="rounded-full text-gray-700 text-[14px] font-semibold"> ({{ certificates.length
                                }})</span></h2>
                    </div>
                </div>
                <div class="relative mt-4">
                    <!-- Flecha anterior -->
                    <button *ngIf="certTotalPages > 1" (click)="certPrev()" [disabled]="certPage === 0"
                        aria-label="Anterior"
                        class="cert-desktop-only absolute -left-3 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-white border border-gray-200 shadow-sm items-center justify-center hover:bg-gray-100 transition-colors disabled:opacity-40">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-chevron-left w-4 h-4 text-[#374151]">
                            <path d="m15 18-6-6 6-6"></path>
                        </svg>
                    </button>

                    <!-- Slider táctil (móvil): 1 card a la vez -->
                    <div class="cert-mobile-scroll overflow-x-auto snap-x snap-mandatory gap-4 px-1 pb-2">
                        <div *ngFor="let item of allCertItems" class="snap-center shrink-0 w-[68%]">
                            <ng-container *ngTemplateOutlet="certCard; context: { $implicit: item }"></ng-container>
                        </div>
                    </div>

                    <!-- Grid paginado (escritorio) -->
                    <div class="cert-desktop-grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 px-2">
                        <ng-container *ngFor="let item of pagedCertItems">
                            <ng-container *ngTemplateOutlet="certCard; context: { $implicit: item }"></ng-container>
                        </ng-container>
                    </div>

                    <!-- Flecha siguiente -->
                    <button *ngIf="certTotalPages > 1" (click)="certNext()" [disabled]="certPage === certTotalPages - 1"
                        aria-label="Siguiente"
                        class="cert-desktop-only absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-white border border-gray-200 shadow-sm items-center justify-center hover:bg-gray-100 transition-colors disabled:opacity-40">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-chevron-right w-4 h-4 text-[#374151]">
                            <path d="m9 18 6-6-6-6"></path>
                        </svg>
                    </button>
                </div>

                <!-- Dots (escritorio) -->
                <div *ngIf="certTotalPages > 1" class="cert-desktop-only items-center justify-center gap-1.5 mt-5">
                    <span *ngFor="let p of [].constructor(certTotalPages); let i = index" (click)="goCertPage(i)"
                        class="h-1.5 rounded-full cursor-pointer transition-all"
                        [ngClass]="certPage === i ? 'w-6 bg-[#374151]' : 'w-1.5 bg-gray-200'"></span>
                </div>

                <!-- Plantilla de card de certificado (reutilizada en móvil y escritorio) -->
                <ng-template #certCard let-item>
                    <!-- Card certificado -->
                    <article *ngIf="!item.learnMore"
                        class="group relative rounded-xl bg-white border border-gray-200 p-3 flex flex-col items-center text-center transition-all hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(11,23,54,0.15)]">
                        <div
                            class="relative w-11 h-11 rounded-full bg-gray-50 border border-gray-200 flex items-center justify-center overflow-hidden">
                            <img [src]="item.providerLogo" (error)="onLogoError($event)" [alt]="item.providerName"
                                class="w-6 h-6 object-contain">
                        </div>
                        <svg viewBox="0 0 24 24" class="absolute top-2.5 right-2.5 w-4 h-4"
                            xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M12 1.6l8.5 4.9v11L12 22.4 3.5 17.5v-11L12 1.6z" fill="#7c3aed" stroke="#7c3aed"
                                stroke-width="1" stroke-linejoin="round"></path>
                            <path d="M8.2 12.2l2.8 2.8 5-5.4" fill="none" stroke="#ffffff" stroke-width="2.2"
                                stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <h4 class="min-h-[2rem] mt-3 px-2 text-xs font-semibold leading-tight text-gray-700 line-clamp-2">
                            {{ item.contentName }}</h4>
                        <p class="text-xs text-[#5F6877] mt-0.5">{{ item.providerName }}</p>
                        <div class="w-full mt-2 pt-2 border-t border-gray-200">
                            <p class="text-[9px] font-semibold uppercase tracking-wider text-[#5F6877]">{{
                                "words.certificate-issued-label" | translate }}</p>
                            <p class="text-[10px] font-semibold mt-0.5 text-gray-700">{{
                                item.certificatedDate | date:'d MMM, y' }}</p>
                        </div>
                    </article>

                    <!-- Tile: Sigue aprendiendo -->
                    <article *ngIf="item.learnMore"
                        class="rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 p-5 flex flex-col items-center justify-center text-center min-h-[220px]">
                        <div
                            class="w-12 h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center mb-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-award w-5 h-5 text-[#5F6877]">
                                <path
                                    d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526">
                                </path>
                                <circle cx="12" cy="8" r="6"></circle>
                            </svg>
                        </div>
                        <h4 class="text-sm font-bold text-[#22304C]">{{ "words.keep-learning" | translate }}</h4>
                        <p class="text-[11px] text-[#5F6877] mt-1.5 max-w-[180px]">{{ "words.keep-learning-desc" |
                            translate }}</p>
                    </article>
                </ng-template>
            </section>

            <section *ngIf="externalCerts.length" class="bg-white  md:rounded-lg box-cards  p-6">
                <h2 class="text-base font-semibold text-gray-700">{{ "words.external-certifications-title" | translate
                    }} <span class="rounded-full text-gray-700 text-[14px] font-semibold"> ({{ externalCerts.length
                        }})</span></h2>
                <div class="mt-4 space-y-2">
                    <div *ngFor="let cert of sortedExternalCerts | slice:0:externalCertsVisibleCount"
                        class="flex items-start gap-3 rounded-xl border border-gray-100 p-3">
                        <span
                            class="w-11 h-11 shrink-0 rounded-lg bg-gray-100 flex items-center justify-center overflow-hidden">
                            <img *ngIf="cert.logo" [src]="cert.logo" [alt]="cert.org" loading="lazy"
                                class="w-9 h-9 object-contain">
                            <svg *ngIf="!cert.logo" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-award w-5 h-5 text-gray-500">
                                <path
                                    d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526">
                                </path>
                                <circle cx="12" cy="8" r="6"></circle>
                            </svg>
                        </span>
                        <div class="min-w-0 flex-1">
                            <p class="text-sm font-semibold leading-tight text-gray-700">{{ cert.title }}</p>
                            <p class="text-xs text-gray-500 mt-0.5">{{ cert.org }} · {{ cert.date }}</p>
                        </div>
                    </div>
                </div>
                <div *ngIf="sortedExternalCerts.length > externalCertsVisibleCount" class="mt-2 flex justify-center">
                    <button type="button" (click)="showMoreExternalCerts()"
                        class="inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 transition">
                        {{ "words.see-more" | translate }} {{ sortedExternalCerts.length - externalCertsVisibleCount }}
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-chevron-down w-3.5 h-3.5">
                            <path d="m6 9 6 6 6-6"></path>
                        </svg>
                    </button>
                </div>
            </section>
        </ng-container>

        <!-- ===== Reconocimientos: Logros ===== -->
        <ng-container
            *ngIf="(effectiveActiveSection === 'resumen' || effectiveActiveSection === 'recognitions') && grikySkillsEnabled && unlockedAchievements.length > 0">
            <div *ngIf="!isSingleSectionMode" class="flex items-center gap-3 pt-3">
                <span class="text-[11px] font-bold uppercase tracking-[0.18em] text-gray-400 whitespace-nowrap">{{
                    "words.stats-recognitions-title" | translate }}</span>
                <span class="h-px flex-1 bg-gray-200"></span>
            </div>

            <section class="bg-white  md:rounded-lg box-cards  p-6">
                <h2 class="text-base font-semibold text-gray-700">{{ "words.achievements" | translate }} <span
                        class="rounded-full text-gray-700 text-[14px] font-semibold"> ({{ unlockedAchievements.length
                        }})</span></h2>
                <div class="achievements-cards-row mt-4 gap-3">
                    <div *ngFor="let achievement of unlockedAchievements | slice:0:5"
                        class="achievements-cards-row__item group relative rounded-xl overflow-hidden border border-gray-200 flex flex-col transition-all hover:-translate-y-0.5 hover:shadow-[0_6px_20px_rgba(34,48,76,0.1)]">
                        <img [src]="badgeUrl(achievement.icon)" [alt]="achievement.name" loading="lazy"
                            class="block w-full aspect-square object-contain">
                    </div>
                </div>
            </section>
        </ng-container>


    </main>

    <!-- ===================== EMPTY STATE: perfil sin contenido ===================== -->
    <div *ngIf="availableProfileSectionsCount === 0" class="flex-1 max-w-5xl w-full mx-auto px-6 md:px-12 py-12">
        <div
            class="rounded-2xl bg-white border border-gray-100 shadow-sm flex flex-col items-center text-center gap-4 py-16 px-8">
            <div class="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                    class="text-gray-400">
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                </svg>
            </div>
            <div class="max-w-sm">
                <h3 class="text-base font-semibold text-gray-700">{{ "words.profile-no-info" | translate }}</h3>

            </div>
        </div>
    </div>

</div>